$(document).ready(function(){
  if ($("#feedback-btn").length){
    $("#feedback-btn").on("click", feedback);
  }
});

function feedback() {
  if ($("#message").length){
    const message = $("#message").val();

    if (message.length) {
      $.ajax({
        url: window.location + "/_/service/no.pasientsikkerhet/feedback",
        type: "POST",
        dataType: "json",
        data: {
          message: message,
        },
        success: function(data) {
          if (data.status == "success") {
            $("#message").hide();
            $("#success").show();
          } else if (data.status == "fail") {
            $("#fail").show().delay(5000).fadeOut();
          }
        },
        error: function(xhr, status, error) {
          $("#fail").show().delay(5000).fadeOut();
        },
        cache: false,
      });
    }
  }
}
